import React from "react";
import { useStore, useSelector } from "react-redux";
import MaximizedPanelContainer from "../MaximizedPanelContainer";
import WeatherChart from "../WeatherChart";
import { useTranslation } from "react-i18next";
import styles from "./index.module.less";

function WeatherChartPanel() {
  const { t } = useTranslation();
  const { select } = useStore();
  const time = useSelector(select.layer.selectTime);
  const weather = useSelector(select.panel.selectWeather);
  if (!weather) return null;
  return (
    <div className={`${styles.weatherChartPanel} panel-container`}>
      <MaximizedPanelContainer name={t("weatherPanel")}>
        <WeatherChart lng={weather.lng} lat={weather.lat} date={time} />
      </MaximizedPanelContainer>
    </div>
  );
}

export default WeatherChartPanel;
